import {
  put,
  takeLatest,
  call,
} from 'redux-saga/effects';
import _ from 'lodash';
import queryString from 'query-string';
import { VERIFY_EMAIL, CONTINUE_AFTER_EMAIL_VERIFICATION } from '../constants';
import {
  verifyEmailSuccess,
  verifyEmailFailure,
} from '../actions';
import { fetchUser } from '../../services/auth';
import { buildLoginPath } from '../../common/lib/redirectToLogin';
import { isClaimedByOtherTab } from '../../common/lib/registrationFlowSession';
import { createNavigateAfterEmailVerified } from './navigateAfterEmailVerifiedSaga';


const createVerifyEmailSagas = (api) => {
  const navigateAfterEmailVerified = createNavigateAfterEmailVerified(api);

  function* confirmVerifyEmailSaga() {
    try {
      const queryParams = queryString.parse(window.location.search);
      const clientId = _.get(queryParams, 'clientId', false);
      const secret = _.get(queryParams, 'secret', false);
      const email = _.get(queryParams, 'email', false);
      const code = _.get(queryParams, 'code', false);
      const response = yield call(api.verifyEmail, {
        clientId: clientId && decodeURIComponent(clientId),
        secret: secret && decodeURIComponent(secret),
        email: email && decodeURIComponent(email),
        code: code && decodeURIComponent(code),
      });
      const statusCode = _.get(response, 'status', false);
      if (statusCode === 200) {
        yield put(verifyEmailSuccess());
      } else {
        const errorDetail = _.get(response, 'data.errors[0].detail', false);
        yield put(verifyEmailFailure(
          statusCode,
          errorDetail,
        ));
      }
    } catch (error) {
      const statusCode = _.get(error.response, 'statusCode', false);
      yield put(verifyEmailFailure(
        statusCode,
        error,
      ));
    }
  }

  function* continueAfterEmailVerificationSaga(action) {
    const { push } = action.payload;

    if (isClaimedByOtherTab()) {
      push(buildLoginPath());
      return;
    }

    const { accessToken } = fetchUser();

    if (!accessToken) {
      push(buildLoginPath());
      return;
    }

    yield call(navigateAfterEmailVerified, push);
  }

  function* watchVerifyEmail() {
    yield takeLatest(VERIFY_EMAIL, confirmVerifyEmailSaga);
  }

  function* watchContinueAfterEmailVerification() {
    yield takeLatest(CONTINUE_AFTER_EMAIL_VERIFICATION, continueAfterEmailVerificationSaga);
  }

  return {
    watchVerifyEmail,
    watchContinueAfterEmailVerification, 
  };
};

export default createVerifyEmailSagas;
